export  const features = [
    {
      title: 'Patient Centric',
      text: 'Focused on improving patient engagement and outcomes with personalized care.',
    },
    {
      title: 'Easy EMR',
      text: 'Simple and intuitive Electronic Medical Records system for efficient documentation.',
    },
    {
      title: 'Insurance',
      text: 'Seamless integration with major insurance providers for hassle-free claims.',
    },
    {
      title: 'Data Science',
      text: 'Leverage AI and analytics to make smarter healthcare decisions.',
    },
  ];